'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customFontScaling = exports.smallCaption = exports.largeCaption = exports.a = exports.p = exports.blockquote = exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.fontColors = undefined;

var _extends2, _extends3, _extends4, _extends5, _extends6, _extends7, _extends8, _extends9, _extends10, _extends11, _extends12;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _aphrodite = require('aphrodite');

var _base = require('../colors/base');

var _base2 = _interopRequireDefault(_base);

var _mediaQuery = require('../layout/mediaQuery');

var _mediaQuery2 = _interopRequireDefault(_mediaQuery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var fontColors = exports.fontColors = {
  primaryFont: _base2.default.blackAt89,
  secondaryFont: _base2.default.blackAt62,
  contrastFont: _base2.default.whiteAt98
};
var baseFontProperties = {
  fontWeight: 500,
  color: fontColors.primaryFont,
  '-webkit-font-smoothing': 'antialiased',
  margin: 0
};

var h1 = exports.h1 = _extends({}, baseFontProperties, (_extends2 = {
  fontSize: '6.173em',
  lineHeight: 1.1,
  letterSpacing: '-1.5px'
}, _defineProperty(_extends2, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '4.953em',
  letterSpacing: '-1.4px'
}), _defineProperty(_extends2, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '3.66em',
  letterSpacing: '-0.8px'
}), _defineProperty(_extends2, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '2.653em',
  letterSpacing: '-0.6px'
}), _defineProperty(_extends2, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '2.013em',
  lineHeight: 1.09,
  letterSpacing: '-0.5px'
}), _extends2));

var h2 = exports.h2 = _extends({}, baseFontProperties, (_extends3 = {
  fontSize: '4.633em',
  lineHeight: 1.16,
  letterSpacing: '-1.2px'
}, _defineProperty(_extends3, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '3.8em',
  letterSpacing: '-1px'
}), _defineProperty(_extends3, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '2.93em',
  letterSpacing: '-0.6px'
}), _defineProperty(_extends3, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '2.213em',
  letterSpacing: '-0.4px'
}), _defineProperty(_extends3, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1.747em'
}), _extends3));

var h3 = exports.h3 = _extends({}, baseFontProperties, (_extends4 = {
  fontSize: '3.473em',
  lineHeight: 1.28,
  letterSpacing: '-1px'
}, _defineProperty(_extends4, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '2.927em',
  letterSpacing: '-0.6px'
}), _defineProperty(_extends4, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '2.347em',
  letterSpacing: '-0.4px'
}), _defineProperty(_extends4, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '1.847em',
  letterSpacing: '-0.2px'
}), _defineProperty(_extends4, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1.52em',
  letterSpacing: '-0.3px'
}), _extends4));

var h4 = exports.h4 = _extends({}, baseFontProperties, (_extends5 = {
  fontSize: '2.606em',
  lineHeight: 1.29,
  letterSpacing: '-0.6px'
}, _defineProperty(_extends5, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '2.253em',
  lineHeight: 1.36,
  letterSpacing: '-0.4px'
}), _defineProperty(_extends5, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '1.873em',
  letterSpacing: '-0.1px'
}), _defineProperty(_extends5, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '1.533em'
}), _defineProperty(_extends5, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1.32em',
  lineHeight: 1.3
}), _extends5));

var h5 = exports.h5 = _extends({}, baseFontProperties, (_extends6 = {
  fontSize: '1.953em',
  lineHeight: 1.39,
  letterSpacing: '-0.3px'
}, _defineProperty(_extends6, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '1.733em',
  lineHeight: 1.38,
  letterSpacing: 'normal'
}), _defineProperty(_extends6, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '1.56em',
  lineHeight: 1.28
}), _defineProperty(_extends6, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '1.28em',
  lineHeight: 1.39
}), _defineProperty(_extends6, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1.153em'
}), _extends6));

var h6 = exports.h6 = _extends({}, baseFontProperties, (_extends7 = {
  fontSize: '1.273em',
  lineHeight: 1.43,
  letterSpacing: 'normal',
  textTransform: 'none'
}, _defineProperty(_extends7, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '1.027em',
  letterSpacing: '-0.1px'
}), _defineProperty(_extends7, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '0.927em',
  lineHeight: 1.44,
  letterSpacing: '0.2px'
}), _extends7));

var blockquote = exports.blockquote = _extends({}, baseFontProperties, (_extends8 = {
  fontSize: '1.953em',
  lineHeight: 1.84,
  letterSpacing: '-0.3px'
}, _defineProperty(_extends8, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '1.733em',
  letterSpacing: 'normal'
}), _defineProperty(_extends8, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '1.53em'
}), _defineProperty(_extends8, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '1.28em'
}), _defineProperty(_extends8, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1.153em'
}), _extends8));

var p = exports.p = _extends({}, baseFontProperties, (_extends9 = {
  fontSize: '1.467em',
  lineHeight: 1.5
}, _defineProperty(_extends9, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '1.333em'
}), _defineProperty(_extends9, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '1.2em'
}), _defineProperty(_extends9, _mediaQuery2.default.maxWidth.tablet, {
  fontSize: '1.067em'
}), _defineProperty(_extends9, _mediaQuery2.default.maxWidth.mobileLarge, {
  fontSize: '1em',
  lineHeight: 1.47
}), _extends9));

var a = exports.a = _extends({}, baseFontProperties, (_extends10 = {
  fontSize: '1.467em',
  lineHeight: 1.5
}, _defineProperty(_extends10, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '1.333em'
}), _defineProperty(_extends10, _mediaQuery2.default.maxWidth.bootstrap.xl, {
  fontSize: '1.2em'
}), _defineProperty(_extends10, _mediaQuery2.default.maxWidth.bootstrap.md, {
  fontSize: '1.067em'
}), _defineProperty(_extends10, _mediaQuery2.default.maxWidth.bootstrap.sm, {
  fontSize: '1em',
  lineHeight: 1.47
}), _extends10));

var largeCaption = exports.largeCaption = _extends({}, baseFontProperties, (_extends11 = {
  fontSize: '0.967em',
  letterSpacing: '0.2px'
}, _defineProperty(_extends11, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '0.88em',
  lineHeight: 1.21
}), _defineProperty(_extends11, _mediaQuery2.default.maxWidth.desktop, {
  fontSize: '0.893em',
  lineHeight: 1.34,
  letterSpacing: '0.1px'
}), _defineProperty(_extends11, _mediaQuery2.default.maxWidth.mobileLarge, {
  lineHeight: 1.19
}), _extends11));

var smallCaption = exports.smallCaption = _extends({}, baseFontProperties, (_extends12 = {
  fontSize: '0.867em',
  lineHeight: 1.38,
  letterSpacing: '0.3px'
}, _defineProperty(_extends12, _mediaQuery2.default.maxWidth.desktopLarge, {
  fontSize: '0.76em',
  lineHeight: 1.36
}), _defineProperty(_extends12, _mediaQuery2.default.maxWidth.mobileLarge, {
  letterSpacing: '0.2px'
}), _extends12));

var customFontScaling = exports.customFontScaling = function customFontScaling(fontBase, customRuleSet) {
  return Object.assign({}, fontBase, customRuleSet);
};

var fontStyles = _aphrodite.StyleSheet.create({
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
  blockquote: blockquote,
  p: p,
  a: a,
  largeCaption: largeCaption,
  smallCaption: smallCaption
});

exports.default = fontStyles;